import React, { Component } from 'react';

import isEqual from 'lodash/isEqual';

import TreeWrapper from './TreeWrapper';

import 'react-dropdown-tree-select/dist/styles.css';

export default class FilterOffer extends Component {
  state = {
    location: {},
  };

  constructor(props) {
    super(props);

    this.conferences = this.props.conferences;
  }

  componentWillReceiveProps = (nextProps) => {
    if (!isEqual(nextProps.value, this.props.value)) {
      this.setState({
        offers: nextProps.value || {},
      });
    }
  };

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.value, this.props.value);
  };

  onChange = (value, selectedNodes) => {
    const conferences = this.conferences;
    const currentOffers = this.props.value;

    /**
     * See if current selection is top level; else it's inside
     */
    if (typeof conferences.find((conference) => conference.name === value.name) !== 'undefined') {
      /**
       * If there isn't a key create one
       */
      if (Object.keys(this.props.value).indexOf(value.name) === -1) {
        currentOffers[value.name] = [];
      }

      if (value.checked === true) {
        /**
         * Reset the array
         */
        currentOffers[value.name] = [];

        currentOffers[value.name].push('All');
      } else {
        const index = currentOffers[value.name].indexOf('All');

        currentOffers[value.name].splice(index, 1);

        if (currentOffers[value.name].length === 0) {
          delete currentOffers[value.name];
        }
      }
    } else {
      let conference = null;
      let fullConference = null;
      let foundSchool = null;

      for (let i = 0; i < conferences.length; i++) {
        foundSchool = conferences[i].children.find((child) => child.name === value.name);
        if (typeof foundSchool !== 'undefined') {
          conference = conferences[i].name;

          fullConference = conferences[i];

          break;
        }
      }

      /**
       * If there isn't a key create one
       */
      if (Object.keys(this.props.value).indexOf(conference) === -1) {
        currentOffers[conference] = [];
      }

      if (value.checked === true) {
        /**
         * Reset if only All is checked
         */
        if (currentOffers[conference][0] === 'All') {
          currentOffers[conference] = [];
        }

        currentOffers[conference].push(foundSchool.name);

        if (currentOffers[conference].length === fullConference.children.length) {
          currentOffers[conference] = ['All'];
        }
      } else {
        /**
         * Ensure going from all to all minus one selects all of the children except the deselected one
         */
        if (currentOffers[conference][0] === 'All') {
          currentOffers[conference].splice(0, 1);

          const foundConference = conferences.find((conf) => conf.name === conference);

          if (currentOffers[conference].length === 0) {
            foundConference.children.forEach((child) => {
              child.checked = true;

              currentOffers[conference].push(child.name);
            });
          }
        }

        const index = currentOffers[conference].indexOf(foundSchool.name);

        currentOffers[conference].splice(index, 1);

        if (currentOffers[conference].length === 0) {
          delete currentOffers[conference];
        }
      }
    }

    this.props.handleChange(currentOffers);
  };

  generateSelectedValues(values) {
    const valueKeys = Object.keys(values || {});
    /**
     * Reset all counties
     */
    this.conferences.forEach((conference) => {
      conference.checked = false;
      conference.value = conference.id;
      conference.key = conference.id;
      conference.label = conference.name;
      conference.children = conference.colleges.map((college) => {
        college.value = college.id;
        college.key = college.id;
        college.label = college.name;
        college.checked = false;
        return college;
      });
    });

    if (valueKeys.length > 0) {
      /**
       * Go through each preselected value, by key
       */
      valueKeys.forEach((valueKey) => {
        /**
         * Try to find the conference
         */
        const found = this.conferences.find((conference) => conference.name === valueKey);
        if (typeof found !== 'undefined') {
          /**
           * See if we're doing an All selection or a child
           */
          if (values[valueKey][0] === 'All' || values[valueKey] === 'All') {
            found.checked = true;

            found.children.forEach((child) => (child.checked = true));
          } else if (values[valueKey].length > 0) {
            /**
             * Set the child to check if it's found. Child could already be checked
             */
            values[valueKey].forEach((value) => {
              const child = found.children.find(
                (childSearch) => childSearch.name.indexOf(value) > -1
              );

              if (typeof child !== 'undefined') {
                child.checked = true;
              }
            });
          }
        }
      });
    }
  }

  render() {
    this.generateSelectedValues(this.props.value);

    return (
      <div className='flexer'>
        <strong>Schools: </strong>
        <TreeWrapper
          data={this.conferences}
          onChange={this.onChange.bind(this)}
          placeholderText='Search for Schools (Defaults to All)'
          showPartiallySelected={true}
          clearSearchOnChange={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/FilterOffer.js